<template>
  <!--<div class="games-section fluid-container post-header">
      <header-games v-bind:playing="url" @home="url=''"></header-games>
      <div id="game_view" class="dark-bg" v-if="url">
          <iframe class="gameIFrame" scrolling="no" v-bind:src="url"></iframe>
      </div>
      <section id="games-all" class="games-section fluid-container post-header" v-if="!url">
          <div class="container">
              <div class="row filter-btns">
                  <div v-for="(cat, index) in categories" class="col-md-2 col-sm-2 col-xs-2 filter-btns-col">
                      <a class="btn btn-lg center block filter-btn filter_block"
                         v-bind:class="{ 'selected_item': categories[category]==cat}" @click="filter(index)">{{cat}}</a>
                  </div>
              </div>
          </div>
          <div class="container-fluid">
              <div id="games_block" class="games-block featured-games row" data-total="126">
                  <div class="games-carousel carousel slide" data-ride="carousel" data-interval="false"
                       data-alias="home"
                       id="carousel-home">
                      <div class="carousel-inner" role="listbox">
                          <div v-for="(page, index) in rows[categories[category]]" class="item"
                               v-bind:class="{ 'active': currentPage==index}">
                              <div class="container" id="games_cont">
                                  <div v-for="game in page"
                                       class="casino-game-block col-lg-3 col-md-3 col-sm-4 col-xs-4 col-xl-3"
                                       data-game-id="179">
                                      <div class="casino-game-image">
                                          <a data-game_id="179">
                                              <img v-bind:alt="game.label"
                                                   v-bind:src="'content/images/'+categories[category]+'/'+game.name+'.jpg'">
                                              <h5 class="casino-game-block-title bottom-right-corner-pos corner-padding txt-preload hide-sm">
                                                  <i class="icon star-icon-white full-star-icon"></i> {{game.label}}
                                              </h5>
                                          </a>
                                          <a @click="open(game)" class="casino-games-btns fade">
                                              <div class="table">
                                                  <div class="table-cell">
                                                      <div class="col-xs-12 center">
                                                          <h5 class="casino-game-block-title corner-padding txt-preload hide-xs">
                                                              <i class="icon star-icon-white full-star-icon"></i>
                                                              {{game.label}} </h5>
                                                          <span class="btn btn-preload">Play</span>
                                                      </div>
                                                  </div>
                                              </div>
                                          </a>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <ol class="carousel-indicators">
                          <li v-for="(page, index) in rows[categories[category]]" data-target="#carousel-home" data-slide-to="0"
                              v-bind:class="{ 'active': currentPage==index}" @click="jump(index)"></li>
                      </ol>
                      <a class="left carousel-control" role="button" data-slide="prev"
                         @click="prev">
                          <i class="icon-arrow-left icon-prev"></i>
                          <span class="sr-only">Previous</span>
                      </a>
                      <a class="right carousel-control" role="button" data-slide="next"
                         @click="next">
                          <i class="icon-arrow-right icon-next"></i>
                          <span class="sr-only">Next</span>
                      </a>
                  </div>
              </div>
          </div>
          <div class="push"></div>
      </section>
  </div>-->
  <div class="container-fluid games-container">
    <header-games v-bind:playing="url" @home="url=''"></header-games>
    <div id="game_view" class="row dark-bg" v-if="url">
      <iframe class="gameIFrame" scrolling="no" v-bind:src="url"></iframe>
    </div>
    <div class="row row-no-gutters categories-xs categories-md text-center" v-if="!url">
      <div v-for="(cat, index) in categories" class="col-md-1 col-sm-2 col-xs-3">
        <a class="btn btn-lg btn-sm btn-xs center block filter-btn filter_block filter-btn-text-xs filter-btn-text-md"
           v-bind:class="{ 'selected_item': categories[category]==cat}"
           @click="filter(index)">{{ cat.replaceAll('_', ' ') }}</a>
      </div>
    </div>
    <div id="games_block" class="games-block featured-games row" data-total="126" v-if="!url">
      <div class="games-carousel carousel slide" data-ride="carousel" data-interval="false"
           data-alias="home"
           id="carousel-home">
        <div class="carousel-inner" style="overflow: unset" role="listbox">
          <div v-for="(page, index) in rows[categories[category]]" class="item"
               v-bind:class="{ 'active': currentPage==index}">
            <div class="container" id="games_cont">
              <div v-for="game in page"
                   class="casino-game-block col-lg-3 col-md-3 col-sm-4 col-xs-4 col-xl-3"
                   data-game-id="179">
                <div class="casino-game-image">
                  <a data-game_id="179">
                    <img v-bind:alt="game.label"
                         v-bind:src="'content/images/'+categories[category]+'/'+game.name+'.jpg'">
                    <h5 class="casino-game-block-title bottom-right-corner-pos corner-padding txt-preload hide-sm">
                      <i class="icon star-icon-white full-star-icon"></i> {{ game.label }}
                    </h5>
                  </a>
                  <a @click="open(game)" class="casino-games-btns fade">
                    <div class="table">
                      <div class="table-cell">
                        <div class="col-xs-12 center">
                          <h5 class="casino-game-block-title corner-padding txt-preload hide-xs">
                            <i class="icon star-icon-white full-star-icon"></i>
                            {{ game.label }} </h5>
                          <span class="btn btn-preload">Play</span>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ol class="carousel-indicators">
          <li v-for="(page, index) in rows[categories[category]]" data-target="#carousel-home"
              data-slide-to="0"
              v-bind:class="{ 'active': currentPage==index}" @click="jump(index)"></li>
        </ol>
        <a class="left carousel-control" role="button" data-slide="prev"
           @click="prev">
          <i class="icon-arrow-left icon-prev"></i>
          <span class="sr-only">Previous</span>
        </a>
        <a class="right carousel-control" role="button" data-slide="next"
           @click="next">
          <i class="icon-arrow-right icon-next"></i>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import LoginMain from '../login-main-component/LoginMainComponent.vue'
import PayInComponent from '../pay-in-component/PayInComponent.vue';
import HeaderGames from '../header-games-component/HeaderGamesComponent.vue'
import axios from 'axios'
//import jQuery from 'jquery'
//import bootsrap from 'bootstrap'

export default {
  components: {LoginMain, HeaderGames},
  dependencies: ['service'],
  data: function () {
    return {
      rows: {},
      category: 0,
      categories: [],
      currentPage: 0,
      url: '',
      slide: 0
    }
  },
  computed: {
    device: function () {
      return this.isMobile() ? 'mobile' : 'desktop';
    }
  },
  mounted: function () {
    window.closeGame = () => {
      this.url = '';
    };
    axios.get(`content/games-${this.device}.json?r=${Math.random()}`).then(r => {
      this.rows = r.data;
      this.categories = Object.keys(this.rows);
    }).catch(e => {
      alert(e);
    })
  },
  methods: {
    isMobile() {
      return navigator.userAgent.match(/Android/i)
          || navigator.userAgent.match(/webOS/i)
          || navigator.userAgent.match(/iPhone/i)
          || navigator.userAgent.match(/iPad/i)
          || navigator.userAgent.match(/iPod/i)
          || navigator.userAgent.match(/BlackBerry/i)
          || navigator.userAgent.match(/Windows Phone/i)
    },
    next: function () {
      let current = this.categories[this.category];
      this.currentPage = (this.currentPage + 1) % this.rows[current].length;
    },
    prev: function () {
      let current = this.categories[this.category];
      this.currentPage = (this.currentPage - 1 + this.rows[current].length) % this.rows[current].length;
    },
    jump: function (index) {
      this.currentPage = index;
    },
    open(game) {
      let company = this.categories[this.category].toUpperCase();
      let split = location.href.split('/');
      //let closeUrl = location.origin + '/' + split[3] + '/close.html';
      //if (company === 'NOVOMATIC')
      let closeUrl = location.origin + '/' + split[3] + '/' + split[4];
      if (this.device === 'desktop') {
        if (company === 'AMATIC')
          closeUrl = location.origin + '/' + split[3] + '/close.html';
        else if (company === 'LUCKY_STREAK')
          closeUrl = null
      }

      this.service.openGame(company, game.name, game.id, this.device, closeUrl, 'static').then(r => {
        if (r.data.errorCode == 0) {
          let url = r.data.url || r.data.game.url;
          if (this.isMobile()) {
            location.href = url;
          } else
            this.url = r.data.url || r.data.game.url;
        } else throw r.data.description;
      });
    },
    filter(index) {
      this.category = index;
      this.currentPage = 0;
    }
  }
}
</script>